<template>
  <v-switch
    color="blue darken-2"
    inset
    v-model="productCountry"
    @change="setGrid()"
    :label="`Show product country code`"
  ></v-switch>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProductCountryToggle",
  data() {
    return {
      productCountry: this.$store.getters.retrieveProductCountry
    };
  },
  methods: {
    ...mapActions(["setProductCountry"]),

    async setGrid() {
      await this.setProductCountry(this.productCountry);
    }
  }
};
</script>

<style lang="sass" scoped>
</style>